<template>
  <div class="nationalClub mainContent top50" style="margin-top:80px;background: #fff;">
    <div class="banner">
      <img src="/static/image/vip_banner_bg-917c.png" />
      <div class="dashboard" @click="loginBox" v-if="!$store.state.token">
        <div class="inner">
          <div class="dashboard__title">请先登录后查看特权</div>
          <div class="dashboard__subtitle">立即登录 &gt;</div>
        </div>
      </div>
    </div>
	
	<div class="_35lz77bA" v-if="$store.state.token">
      <div class="_24vddGqv">
        <div class="_3LPqql-T">
          <section>
            <div class="_3EUFt5Wv">
              <div class="_29gnuiyG" style="margin: 36px 0px 37px">
                <div class="_35_vygsc">
                  <h1 style="margin-top: 0px">晋级条件</h1>
                </div>
                <div class="_2zJiZW9W"></div>
              </div>
              <div class="_3VD5zTpM">
				<div class="_2szQExG9">
				  <img class="_1nSvFFDr" src="/static/image/passway.4557a2a9.png" />
				  <div class="_3d_hDAu4">
				    <div class="_15yexfD5">当前等级</div>
				    <div class="_3cIZGfn2" id="currentVip">VIP{{ $store.state.userInfo.vip || '0' }}</div>
				  </div>
				</div>  
                <div class="_2szQExG9">
                  <img
                    class="_1nSvFFDr"
                    src="data:image/png;base64,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"
                  />
                  <div class="_3d_hDAu4">
                    <div class="_15yexfD5">累计流水</div>
                    <div class="_3cIZGfn2" id="n1"><span>￥</span>{{ Math.floor($store.state.userInfo.totalgame) || 0 }}</div>
                  </div>
                </div>
                <div class="_2szQExG9">
                  <img class="_1nSvFFDr" src="/static/image/vip_promotion_2_icon-4840.png" />
                  <div class="_3d_hDAu4">
                    <div class="_15yexfD5">累计充值</div>
                    <div class="_3cIZGfn2" id="n2"><span>￥</span>{{ Math.floor($store.state.userInfo.paysum) || 0 }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="maxnext" style="margin-top: 20px;">
              <div class="maxnext1">
				<div class="maxnext3">
				  <div v-if="!isMaxLevel">
				    <span>还需充值: </span>
				    <span :style="{color: needRecharge <= 0 ? 'green' : 'red'}">
				      {{ needRecharge <= 0 ? '已满足' : '￥' + needRecharge }}
				    </span>
				    <br>
				    <span>还需流水: </span>
				    <span :style="{color: needFlow <= 0 ? 'green' : 'red'}">
				      {{ needFlow <= 0 ? '已满足' : '￥' + needFlow }}
				    </span>
				  </div>
				  <div v-else style="color: #333;">
				    已达到最高等级
				  </div>
				</div>  
                
                <div class="scroll-indicator">
                  <div class="arrow-container">
                    <!-- 减少箭头数量至7个，保持流畅感同时避免拥挤 -->
                    <span class="flowing-arrow">➤</span>
                    <span class="flowing-arrow">➤</span>
                    <span class="flowing-arrow">➤</span>
                    <span class="flowing-arrow">➤</span>
                    <span class="flowing-arrow">➤</span>
                    <span class="flowing-arrow">➤</span>
                    <span class="flowing-arrow">➤</span>
                    <span class="flowing-arrow">➤</span>
                    <span class="flowing-arrow">➤</span>
                    <span class="flowing-arrow">➤</span>					
                  </div>
                </div>
                <div class="maxnext2">升级至{{ nextVipLevel.vipname || '最高级' }}</div>
              </div>
            </div>
            <div class="_29gnuiyG" style="53px 0px 13px;">
              <div class="_35_vygsc">
                <h1 style="margin-top: 0px">返水比例</h1>
              </div>
              <div class="_2zJiZW9W"></div>
            </div>
            
            <ul class="_1qdtjegd item1">
              <li class="sWAv_g1H" style="background: #fafafa;color:#000;">
                <div style="color:#000; font-weight: 700;">VIP等级</div>
                <div style="color:#000;">真人返水</div>
                <div style="color:#000;">电子返水</div>
                <div style="color:#000;">棋牌返水</div>
                <div style="color:#000;">体育返水</div>
                <div style="color:#000;">彩票返水</div>
                <div style="color:#000;">电竞返水</div>
              </li>
              <li style="background: #fff;color:#000;" v-for="(item, index) in vipLis" :key="index">
                <img src="/static/image/vip_icon_5_bright-4a8c.png" />
                <div class="-p-khenT">{{ item.vipname }}</div>
                <div style="color:#000;">{{ item.realperson }}%</div>
                <div style="color:#000;">{{ item.electron }}%</div>
                <div style="color:#000;">{{ item.joker }}%</div>
                <div style="color:#000;">{{ item.sport }}%</div>
                <div style="color:#000;">{{ item.lottery }}%</div>
                <div style="color:#000;">{{ item.e_sport }}%</div>
              </li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'vip',
  data() {
    return {
      vipLis: [],
      nextVipLevel: {},
      needRecharge: 0,
      needFlow: 0,
      isMaxLevel: false
    };
  },
  created() {
    this.uservip();
  },
  methods: {
    uservip() {
      this.$apiFun.post('/api/uservip', {}).then(res => {
        if (res.code === 200) {
          this.vipLis = res.data;
          this.calculateUpgradeCondition();
        }
      });
    },
    loginBox() {
      $('.mask').fadeOut(300);
      $('.mask.login').fadeIn(300);
    },
    // 计算升级所需条件
    calculateUpgradeCondition() {
      const currentVipLevel = Number(this.$store.state.userInfo.vip) || 0;
      // 找到当前等级在列表中的索引
      const currentIndex = this.vipLis.findIndex(item => {
        // 从VIP名称中提取数字部分进行比较
        const vipNum = parseInt(item.vipname.replace('VIP', ''));
        return vipNum === currentVipLevel;
      });
      
      // 确定下一等级
      if (currentIndex >= 0 && currentIndex < this.vipLis.length - 1) {
        this.nextVipLevel = this.vipLis[currentIndex + 1];
        this.isMaxLevel = false;
        
        // 计算还需要的充值和流水
        const currentRecharge = Number(this.$store.state.userInfo.paysum) || 0;
        const requiredRecharge = Number(this.nextVipLevel.recharge) || 0;
        this.needRecharge = Math.max(0, requiredRecharge - currentRecharge);
        
        const currentFlow = Number(this.$store.state.userInfo.totalgame) || 0;
        const requiredFlow = Number(this.nextVipLevel.flow) || 0;
        this.needFlow = Math.max(0, requiredFlow - currentFlow);
      } else {
        // 已经是最高等级
        this.isMaxLevel = true;
        this.nextVipLevel = {};
        this.needRecharge = 0;
        this.needFlow = 0;
      }
    }
  },
  updated() {
    const that = this;
    // VIP等级切换事件
    for (let i = 0; i < 10; i++) {
      $(`.vip${i + 1}`).click(function () {
        const vip = that.vipLis[i] || {}; // 防止 undefined
        $('#n2').html(`<span>￥</span>${vip.recharge || '0'}`);
        $('#n1').html(`<span>￥</span>${vip.flow || '0'}`);
      });
    }
  },
  watch: {
    // 当VIP列表或用户信息变化时重新计算升级条件
    vipLis() {
      this.calculateUpgradeCondition();
    },
    '$store.state.userInfo.vip'() {
      this.calculateUpgradeCondition();
    },
    '$store.state.userInfo.paysum'() {
      this.calculateUpgradeCondition();
    },
    '$store.state.userInfo.totalgame'() {
      this.calculateUpgradeCondition();
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../../static/css/chunk-06254e6a.f0cc50a1.css';
@import '../../../static/css/chunk-3b1c96fc.08284057.css';
@import '../../../static/css/chunk-645a6edf.25ca78d5.css';
@import '../../../static/css/chunk-efd233ae.5a783923.css';
@import '../../../static/css/chunk-0aa69727.eb3a1cbb.css';

._35lz77bA, ._35lz77bA ._24vddGqv {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
}
._35lz77bA {
    width: 100%;
    min-height: 100vh;
    -webkit-flex-direction: column;
    flex-direction: column;
    overflow: hidden;
}
._29gnuiyG ._35_vygsc{padding-left:68px;width:358px;-webkit-flex-shrink:0;flex-shrink:0}
._29gnuiyG ._35_vygsc h1{font-size:46px;color:#3f5075;line-height:46px;margin-bottom:7px}
._29gnuiyG ._35_vygsc h2{font-size:24px;color:#3f5075;font-family:serif!important}
._29gnuiyG{
	width:1200px;
	margin:0 auto;
	height:64px;
	background-image:url(data:image/png;base64,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);
	background-repeat:no-repeat;
	background-size:contain;
	display:-webkit-box;
	display:-webkit-flex;
	display:flex
}

._1qdtjegd{
	font-family:PingFangSC-Regular,-apple-system,Hiragino Sans GB,Monospaced Number,Helvetica Neue,Helvetica,Arial,sans-serif;
	width:100%;
	margin:55px 0 30px;
	position:relative;
	font-size:18px;
	display:-webkit-box;
	display:-webkit-flex;
	display:flex;
	background-color:#fff
}

._1qdtjegd li .-p-khenT,._1qdtjegd li.sWAv_g1H{background: #fff;color:#d7967f;font-weight:bolder}
._1qdtjegd li img{width:54px;height:54px;visibility:hidden;position:absolute;top:-27px;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}
._1qdtjegd li div{
	width:100px;
	height:70px;
	border-right-color:#f0f0f0;
	border-top-color:#f0f0f0;
	border-left:1px solid #f0f0f0;
	border-bottom:1px solid #f0f0f0;
	border-right-style:solid;
	border-top-style:solid;
	display:-webkit-box;
	display:-webkit-flex;
	display:flex;
	-webkit-box-pack:center;
	-webkit-justify-content:center;
	justify-content:center;
	-webkit-box-align:center;
	-webkit-align-items:center;
	align-items:center
}

._3EUFt5Wv ._3VD5zTpM{
	display:-webkit-box;
	display:-webkit-flex;
	display:flex;
	-webkit-box-pack:justify;
	-webkit-justify-content:space-between;
	justify-content:space-between;
	margin:40px 0
}
._3EUFt5Wv ._3VD5zTpM ._2szQExG9{
	width:602px;height:186px;
	background-image:url(/static/image/vip_promotion_1-f151.png);
	background-position:50%;
	background-repeat:no-repeat;
	background-size:cover;
	display:-webkit-box;
	display:-webkit-flex;
	display:flex;
	-webkit-box-pack:center;
	-webkit-justify-content:center;
	justify-content:center;
	-webkit-box-align:center;
	-webkit-align-items:center;
	align-items:center
}
._3EUFt5Wv ._3VD5zTpM ._2szQExG9:nth-of-type(n+2){margin-left:12px}
._3EUFt5Wv ._3VD5zTpM ._2szQExG9 ._1nSvFFDr{width:148px;height:auto}
._3EUFt5Wv ._3VD5zTpM ._2szQExG9 ._3d_hDAu4{margin-left:20px}
._3EUFt5Wv ._3VD5zTpM ._2szQExG9 ._3d_hDAu4 ._15yexfD5{font-size:20px;line-height:28px;color:#98a3b1}
._3EUFt5Wv ._3VD5zTpM ._2szQExG9 ._3d_hDAu4 ._3cIZGfn2{color:#d7967f;font-size:50px;line-height:50px;font-weight:700}
._3LPqql-T{
	width:100%;
	height:auto;
	background:url(/static/bg-eb3e.jpg) top;
	background-size:100% auto;
	padding-bottom:80px;font-family:PingFangSC-Regular,-apple-system,Hiragino Sans GB,Monospaced Number,Helvetica Neue,Helvetica,Arial,sans-serif;
	-webkit-font-smoothing:antialiased}
	._3LPqql-T section{
		width:1200px;
		margin:0 auto
}


._1qdtjegd li div{
    width: 109px!important;

}
.nationalClub .banner {
    max-height: 430px!important;
    text-align: center;
    overflow: hidden;
}
.nationalClub .banner  img{
    display: block;
    margin: 0 auto;   /* 水平居中 */
    max-width: 100%;  /* 宽度不会超过父容器 */
    height: auto;     /* 等比例缩放 */
}
.nationalClub .banner .dashboard {
    bottom: 0!important;
}
._29gnuiyG ._35_vygsc h1 {
    color: #000!important;
}
._1qdtjegd {
    color: #fafafa!important;
     background-color: #fafafa!important;
}
._1qdtjegd:before {

    background-image: linear-gradient(135deg, #000, #000)!important;
}
._1qdtjegd li {

    color: #fafafa!important;
  
}
.nationalClub {
    padding-bottom: 1.6rem!important;
}
.scroll-indicator {
  color: #d7967f;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  min-width: 120px;
  overflow: hidden;
}

.arrow-container {
  display: flex;
  align-items: center;
  width: 100%;
  animation: flowForward 5s linear infinite; /* 调整动画速度更自然 */
}

.flowing-arrow {
  font-size: 38px;
  font-weight: bold;
  margin: 0 6px; /* 增加间距避免拥挤 */
  opacity: 0.9; /* 统一透明度，解决颜色不一致问题 */
}

/* 优化动画范围，适应减少后的箭头数量 */
@keyframes flowForward {
  0% {
    transform: translateX(-80%);
  }
  100% {
    transform: translateX(80%);
  }
}
.maxnext {
  width: 100%;
  margin: 20px auto;
  padding: 0 15px;
}

.maxnext1 {
  background-color: #fff;
  border-radius: 8px;
  border: 1px solid #f0f0f0;
  padding: 15px 30px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.03);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  min-height: auto;
}

.maxnext2 {
  font-size: 20px;
  font-weight: 700;
  color: #d7967f;
  padding-right: 25px;
  border-right: 1px solid #f0f0f0;
  white-space: nowrap;
}

.maxnext3 {
  font-size: 16px;
  padding-left: 25px;
  line-height: 1.5;
  min-width: 200px;
  
  span:first-child {
    color: #666;
    margin-right: 8px;
  }
  
  br {
    margin: 2px 0;
  }
}

@media (max-width: 768px) {
  .maxnext1 {
    flex-direction: column;
    padding: 12px 15px;
  }
  
  .scroll-indicator {
    display: none;
  }
  
  .maxnext2 {
    border-right: none;
    border-bottom: 1px solid #f0f0f0;
    padding: 0 0 10px 0;
    margin-bottom: 10px;
    text-align: center;
    font-size: 18px;
  }
  
  .maxnext3 {
    padding: 0;
    text-align: center;
    font-size: 15px;
    line-height: 1.4;
    min-width: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mode/vip.vue